"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _ = require("../");

var _Module = require("../Module");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class LayoutInboxCompose extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onSave", status => {
      const _this$props = this.props,
            id = _this$props.id,
            index = _this$props.index,
            schema = _this$props.schema,
            formData = _this$props.formData,
            formContext = _this$props.formContext;

      const newFormData = _extends({}, formData, {
        createdAt: (0, _moment.default)().format()
      });

      if (formContext.onSaveMessage) {
        formContext.onSaveMessage({
          index: index,
          formData: newFormData
        });
      }
    });

    _defineProperty(this, "onDiscard", () => {
      const _this$props2 = this.props,
            id = _this$props2.id,
            index = _this$props2.index,
            schema = _this$props2.schema,
            formData = _this$props2.formData,
            formContext = _this$props2.formContext;

      if (formContext.onDiscardDraft) {
        formContext.onDiscardDraft({
          index: index,
          formData: formData
        });
      }
    });

    _defineProperty(this, "renderFooter", () => {
      const saveButton = {
        title: "Send",
        onClick: () => this.onSave('new'),
        children: [{
          title: "Save as draft",
          onClick: () => this.onSave('draft')
        }, {
          title: "Save and publish",
          onClick: () => this.onSave('publish')
        }]
      };
      const submitButton = {
        title: "Save",
        onClick: this.onSave
      };
      const discardButton = {
        title: "Discard",
        onClick: this.onDiscard
      };
      return _react.default.createElement(_Module.ModuleFooter, null, _react.default.createElement(_.ButtongroupInline, null, _react.default.createElement(_.ButtonSecondary, submitButton), _react.default.createElement(_.ButtonSecondary, discardButton)));
    });
  }

  render() {
    return _react.default.createElement("article", {
      className: "admin-inbox-editor__compose"
    }, this.props.children, this.renderFooter());
  }

}

_defineProperty(LayoutInboxCompose, "defaultProps", {
  formData: {}
});

var _default = LayoutInboxCompose;
exports.default = _default;
module.exports = exports.default;